import * as React from "react"
import { Stack, Skeleton as MUISkeleton, styled } from "@mui/material"

const StyledSkeleton = styled(MUISkeleton)<any>(
  ({ theme }) => `
  background-color: ${theme.palette.background.dark} ; 
  
`
)

export const WidgetSkeleton = ({ qty = 1 }) => {
  return (
    <>
      {Array.from({ length: qty }, (_, i) => i).map((_, i) => (
        <React.Fragment key={i}>
          <Stack spacing={1}>
            <StyledSkeleton variant="rounded" width="100%" height={100} />
            <StyledSkeleton
              variant="rounded"
              width="100%"
              height={15}
              animation="wave"
            />
            <StyledSkeleton
              variant="rounded"
              width="60%"
              height={15}
              animation={false}
            />
          </Stack>
        </React.Fragment>
      ))}
    </>
  )
}

export const PageSkeleton = () => {
  return (
    <Stack spacing={1}>
      <StyledSkeleton variant="rounded" width="100%" height={20} />
      <StyledSkeleton
        variant="rounded"
        width="100%"
        height={20}
        animation="wave"
      />
      <StyledSkeleton
        variant="rounded"
        width="100%"
        height={15}
        animation={false}
      />
    </Stack>
  )
}
